import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../../styles/proposition-bets-widget.module.scss";
import {OddsTooltip} from "../../../../../core/components/odds/tooltip/odds-tooltip";
import {TOOLTIP_PLACEMENT} from "../../../../../core/components/tooltip/tooltip-consts";
import {PropositionBetsWidgetRowOptionName} from "./proposition-bets-widget.row.option.name";
import {PropositionBetsWidgetRowOptionRate} from "./proposition-bets-widget.row.option-rate";
import {APP, GAME_STATUSES} from "../../../../../core/app/consts";
import {useBookieClick} from "../../../../../infrastructure/hooks/useBookieClick";
import {LINK_REL, WIDGET_TYPES} from "../../../../../core/consts";
import {PREDICTION_WIDGET} from "../../../../prediction-widget/predictions-widget.consts";
import {PROPOSITION_BETS} from "../../../proposition-bets-widgets.consts";
import {Link} from "../../../../../core/components/link/link";

export const PropositionBetsWidgetRowOption = observer(({controller, row, option, hasThreeOption}) => {
  const {state, config} = controller;
  const {bookmaker, game, sportTypeId, statusGroup, currentLinkModel} = state;
  const {source} = config;
  const {lineTypeId} = row;

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
      bookieId: bookmaker?.id,
      bookieName: bookmaker?.name,
      urlLink: bookmaker?.link,
      widget: APP.ANALYTICS.WIDGET_TYPES[WIDGET_TYPES.propositionBets],
      impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.tooltip,
      hasOdds: !!bookmaker,
      subSource: PREDICTION_WIDGET.TABS_LABEL.props,
      status: game.statusGroup,
      marketType: lineTypeId,
      buttonType: PROPOSITION_BETS.ANALYTICS.BOOKIE_BUTTON_TYPE.odds,
      currentLinkModelName: currentLinkModel?.name,
      source
    });

  const betsImpressionParams = {
    bookieId: bookmaker?.id,
    bookieName: bookmaker?.name,
    sportTypeId
  }

  const tooltipProps = {
    option,
    bookmaker,
    bookieHrefModel,
    onClick: () => onBookieClick(),
    placement: TOOLTIP_PLACEMENT.bottom,
    betsImpressionParams,
    showOriginalOdds: statusGroup !== GAME_STATUSES.ended,
    controller
  };

  const containerProps = {
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER,
    className: classNames(styles.option_cell, {[styles.three_option]: hasThreeOption, [styles.win_option]: option?.isWon}),
    onClick: (e) => {
      e.stopPropagation();

      return onBookieClick()
    }
  }

  const nameProps = {
    row,
    option
  }

  const rateProps = {
    controller,
    betsImpressionParams,
    option
  }

  return (
    <OddsTooltip {...tooltipProps}>
      <Link {...containerProps}>
        <PropositionBetsWidgetRowOptionName {...nameProps}/>
        <PropositionBetsWidgetRowOptionRate {...rateProps}/>
      </Link>
    </OddsTooltip>
  )
});
